import { render, staticRenderFns } from "./context_menu_demo.vue?vue&type=template&id=3db01ebe&scoped=true&"
import script from "./context_menu_demo.vue?vue&type=script&lang=ts&"
export * from "./context_menu_demo.vue?vue&type=script&lang=ts&"
import style0 from "./context_menu_demo.vue?vue&type=style&index=0&id=3db01ebe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db01ebe",
  null
  
)

export default component.exports